import { Pipe, PipeTransform } from '@angular/core';
import { DropDownOption } from 'src/app/product-capture/model/interfaces/drop-down-option.interface';

@Pipe({
  name: 'selectTitle'
})
export class SelectTitlePipe implements PipeTransform {

  transform(item: DropDownOption): string {
    const { displayValue: label } = item;

    const title = label?.split('<br>') || [];
    return title?.length ? title.join(' | ') : label;
  }

}
